// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const FacebookIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="8.564"
    height="18.576"
    viewBox="0 0 8.564 18.576"
    fill="currentColor"
  >
    <path
      d="M46.031,31.033h-2.54v9.306H39.642V31.033h-1.83v-3.27h1.83V25.646a3.609,3.609,0,0,1,3.883-3.883l2.851.012v3.174H44.307a.783.783,0,0,0-.816.891v1.925h2.876Z"
      transform="translate(-37.812 -21.763)"
    />
  </Icon>
);

export default FacebookIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Social/Facebook.js